import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../components/Login/Login';
import { EmployeeRoute } from './PrivateRoute';
import EmployeeParkingLots from '../pages/EmployeeParkingLots/EmployeeParkingLots';
import UserInfo from '../pages/UserInfomation/UserInfo';
import AboutPage from '../pages/About/AboutPage';
import NotFound from '../pages/NotFound/NotFound';
import UserForgotPwd from '../components/UserForgotPassword/UserForgetPwd';

const employeePage = (page) => <EmployeeRoute>{page}</EmployeeRoute>;

const AppRoute = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/employee/parking-lots" replace />} />
    <Route path="/about" element={<AboutPage />} />
    <Route path="/login" element={<Login />} />
    <Route path="/employee/forgot-password" element={<UserForgotPwd />} />
    <Route path="/employee/parking-lots" element={employeePage(<EmployeeParkingLots />)} />
    <Route path="/employee/info" element={employeePage(<UserInfo />)} />
    <Route path="/employee/manage-vehicle" element={<Navigate to="/employee/parking-lots" replace />} />
    <Route path="/employee/view-history-vehicle" element={<Navigate to="/employee/parking-lots" replace />} />
    <Route path="/employee/scan" element={<Navigate to="/employee/parking-lots" replace />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoute;
